
import { Vue, Component, Prop, PropSync } from 'vue-property-decorator'

@Component({
  name: 'detail'
})
export default class Detail extends Vue {
  @PropSync('visible', { type: Boolean })
  private dialogVisible!: boolean

  @Prop({ type: Object })
  private data!: object|any
}
